import Vue from "vue";
import Vuex, { createLogger } from "vuex";
import login from "./modules/login";
import home from "@/store/modules/home";
import base from "@/store/modules/base";
import config from "@/store/modules/config";

Vue.use(Vuex);

const debug = process.env.NODE_ENV !== "production";

export default new Vuex.Store({
    modules: {
        login,
        home,
        base,
        config
    },
    strict: debug,
    plugins: debug ? [createLogger()] : []
});
